"use client"

import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: "group flex items-start gap-3 w-full p-4 rounded-lg border shadow-lg backdrop-blur-sm",
          title: "text-sm font-medium",
          description: "text-sm opacity-80",
          actionButton: "h-7 px-3 text-xs font-medium rounded-md transition-colors cursor-pointer",
          cancelButton: "h-7 px-3 text-xs font-medium rounded-md transition-colors cursor-pointer",
          success: "bg-emerald-950/90 border-emerald-500/50 text-emerald-100 [&_svg]:text-emerald-400",
          error: "bg-red-950/90 border-red-500/50 text-red-100 [&_svg]:text-red-400",
          warning: "bg-amber-950/90 border-amber-500/50 text-amber-100 [&_svg]:text-amber-400",
          info: "bg-blue-950/90 border-blue-500/50 text-blue-100 [&_svg]:text-blue-400",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
